export class ImageCategoryIcon
{
  idCompany: number;
  categoryName: string;
  icon: string;
}
